<template>
  <ul class="list-group h-100" v-if="sold_players.length">
    <li class="list-group-item bg-grad-green fw-bold onepadding">
      Sold players
      <i
        class="bi bi-chevron-double-down text-primary float-end"
        v-if="!show_all"
        @click="toggleShowAll()"
      ></i>
      <i
        class="bi bi-chevron-double-up text-danger float-end"
        v-if="show_all"
        @click="toggleShowAll()"
      ></i>
    </li>
    <li
      class="list-group-item onepadding midtxt bg-grad-green"
      v-for="p in sold_players"
      :key="p.id"
    >
      <div class="row d-flex align-items-center">
        <div class="col-2"><PhotoSmall :player_id="p.id"></PhotoSmall></div>
        <div class="col-4 text-start">{{ p.name }}</div>
        <div class="col"><LogoSmall :path="p.icon"></LogoSmall></div>
        <div class="col text-end">
          <div class="dropdown">
            <i
              class="bi bi-chevron-down float-start"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="fetchBids(p.id)"
            ></i>
            <ul class="dropdown-menu">
              <li class="dropdown-item" v-for="p in sorted_bids" :key="p">
                <div class="row midtxt text-muted">
                  <div class="col-8">{{ teamName(p.team_id) }}</div>
                  <div class="col-4">
                    <div class="float-end">
                      {{ formatToIndianCurrency(p.amount) }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <span class="p-2"> {{ formatToIndianCurrency(p.sale_price) }}</span>
        </div>
      </div>
      <div class="row" v-if="expand_bids_id == p.id">
        <BidsList :player_id="p.id"></BidsList>
      </div>
    </li>
  </ul>
</template>
<script setup>
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
import { ref, onMounted, computed, onBeforeMount } from "vue";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
import PhotoSmall from "../../bidder/liveplayer/PhotoSmall.vue";
import BidsList from "./BidsList.vue";
const store = useStore();
const players_list = ref([]);
const team_icon_list = ref([]);
const show_all = ref(false);
const expand_bids_id = ref("");
const player_bids = ref([]);
const fetchBids = async (id) => {
  player_bids.value = [];
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("player_id", id);
  player_bids.value = bids;
};
const sorted_bids = computed(() => {
  var arr = [];
  player_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  //last_bid_amount.value = sorted_arr[0].amount + auction.bid_increment;
  return sorted_arr;
});
const expandBids = (id) => {
  if (expand_bids_id.value != id) {
    expand_bids_id.value = id;
  } else {
    expand_bids_id.value = "";
  }
};
const toggleShowAll = () => {
  show_all.value = !show_all.value;
};
onBeforeMount(() => {
  fetchTeamLogoList();
});
onMounted(() => {
  setTimeout(() => {
    fetchSoldPlayers();
  }, 1000);
});
const fetchSoldPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  players_list.value = players;
  setupSoldListner();
  setupDeleteListner();
};
const setupSoldListner = () => {
  const channels = supabase
    .channel("auctioneer-sold-players-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "players",
        filter: `auction_id=eq.${store.live_auction}`,
      },
      (payload) => {
        console.log("Change received!", payload);
        players_list.value = [];
        fetchSoldPlayers();
      }
    )
    .subscribe();
};
const setupDeleteListner = () => {
  const channels = supabase
    .channel("auctioneer-soldplayers-delete-channel")
    .on(
      "postgres_changes",
      { event: "DELETE", schema: "public", table: "players" },
      (payload) => {
        //console.log("Change received!", payload);
        var del_id = payload.old.id;
        players_list.value = players_list.value.filter(
          (player) => player.id !== del_id
        );
      }
    )
    .subscribe();
};
const fetchTeamLogoList = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("id, name ,icon")
    .eq("auction_id", store.live_auction);
  team_icon_list.value = teams;
};
const sold_players = computed(() => {
  var arr = [];
  players_list.value.forEach((p) => {
    if (p.team_id) {
      team_icon_list.value.forEach((i) => {
        if (i.id == p.team_id) {
          p.icon = i.icon;
        }
      });
      arr.push(p);
    }
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort(
    (a, b) => new Date(b.sold_at) - new Date(a.sold_at)
  );
  return show_all.value ? sorted_arr : sorted_arr.slice(0, 5);
  //return sorted_arr;
});
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
const teamName = (id) => {
  const result = team_icon_list.value.find((item) => item.id === id);
  return result.name;
};
</script>
<style scoped>
.onepadding {
  padding: 1px;
}
.midtxt {
  font-size: 10px;
}
.half-screen-scrollable {
  height: 50vh; /* 50% of the viewport height */
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
}
</style>
